export default {
  // header
  headerImg: 'http://music.chinaman.cn/mybigdatas/ids/static/top-text.png',
  navList: [{
    text: "Home",
    url: "/",
  },
  {
    text: "Organizer",
    url: "/organizing",
  },
  {
    text: "Committee",
    url: "/committee",
  },
  {
    text: "Keynotes",
    url: "/session",
  },
  {
    text: "Program",
    url: "/program",
  },
  {
    text: "Submissions",
    url: "/submissions",
  },
  {
    text: "Registration",
    url: "/reg",
  },
  {
    text: "For Attendees",
    url: "sb",
    children: [{
      text: "Visa",
      url: "/visa",
    },
    {
      text: "Venue",
      url: "/travel",
    },
    {
      text: "Travel",
      url: "/traveltwo",
    },
    {
      text: "Hotel",
      url: "/hotel",
    },
    ],
  },
  {
    text: "Sponsors",
    url: "/sponsors",
  },
  {
    text: "Awards",
    url: "/awards",
  },
  ],
  // header
  // index
  indexTitle1: 'General Information',
  indexText1: 'The institutional organizer of IDS 2024 is the Jiangnan University, China. Like its previous biennial IDS conferences, the objective of 23rd IDS is to offer the most cutting-edge and comprehensive global forum for communicating findings and information related to the study, advancement, and use of drying/dewatering sciences and technology. This Symposium will be held in the Worldhotel Grand Juna Wuxi, Wuxi, China on December 3-6, 2024 and aims to bring together leading scientists and engineers from academia and industry will be gathered at this symposium from all over the world. An Award program will be also part of the event for the international drying community. This Symposium is the 23rd event in the series founded by Professor Arun S. Mujumdar at McGill University, Montreal, Canada, in 1978.',
  indexTitle2: 'Important Dates',
  indexdateList: [{
    date: "March 15, 2024",
    text: "Deadline for abstract submission",
  },
  {
    date: "March 31, 2024",
    text: "Notification of abstract acceptance",
  },
  {
    date: "April 30, 2024",
    text: "Deadline for manuscript submission"
  },
  {
    date: "June 15, 2024",
    text: "Notification of manuscript acceptance",
    // acceptance
  },
  {
    date: "July 1, 2024",
    text: "Deadline for “early bird” registration",
  },
  {
    date: "September 1, 2024",
    text: "Final deadline for registration"
  },
  ],
  indexTitle3: 'Related News',
  indexText3: 'First Announcement and Call for Papers',
  indexText4: 'Previous IDS Conferences',
  indexText5: [{
    title: "1st IDS (IDS1978): ",
    text: "Montreal, Canada,"
  },
  {
    title: "2nd IDS (IDS1980): ",
    text: "Montreal, Canada"
  },
  {
    title: "3rd IDS (IDS1982): ",
    text: "Birmingham, UK"
  },
  {
    title: "4th IDS (IDS1984): ",
    text: "Kyoto, Japan"
  },
  {
    title: "5th IDS (IDS1986): ",
    text: "Cambridge, USA"
  },
  {
    title: "6th IDS (IDS1988): ",
    text: "Versailles, France"
  },
  {
    title: "7th IDS (IDS1990): ",
    text: "Prague, Czechoslovakia"
  },
  {
    title: "8th IDS (IDS1992): ",
    text: "Montreal, Canada"
  },
  {
    title: "9th IDS (IDS1994): ",
    text: "Gold Coast, Australia"
  },
  {
    title: "10th IDS (IDS1996): ",
    text: "Krakow, Poland"
  },
  {
    title: "11th IDS (IDS1998): ",
    text: "Halkidiki, Greece"
  },
  {
    title: "12th IDS (IDS2000): ",
    text: "Noordwijkerhout, Netherlands",
  },
  {
    title: "13th IDS (IDS2002): ",
    text: "Beijing, China"
  },
  {
    title: "14th IDS (IDS2004): ",
    text: "Sao Paulo, Brazil"
  },
  {
    title: "15th IDS (IDS2006): ",
    text: "Budapest, Hungary"
  },
  {
    title: "16th IDS (IDS2008): ",
    text: "Hyderabad, India"
  },
  {
    title: "17th IDS (IDS2010): ",
    text: "Magdeburg, Germany"
  },
  {
    title: "18th IDS (IDS2012): ",
    text: "Xiamen, China"
  },
  {
    title: "19th IDS (IDS2014): ",
    text: "Lyon, France"
  },
  {
    title: "20th IDS (IDS2016): ",
    text: "Gifu, Japan"
  },
  {
    title: "21st IDS (IDS2018): ",
    text: "Valencia, Spain"
  },
  {
    title: "22nd IDS (IDS2020/2022): ",
    text: "Worcester, USA"
  },
  {
    title: "23rd IDS (IDS2024): ",
    text: "Wuxi, China"
  },
  ],
  indexText6: "Log in to My Dashboard",
  indexText7: "Email",
  indexText8: "Password",
  indexText9: "Login",
  indexText10: "Create Account",
  indexText11: "Please Login first before",
  indexText12: "Abstract submission",
  indexText13: "Full paper submission",
  indexText14: "Online registraction",
  indexText15: "IDS 2024 Theme",
  indexText16: "http://music.chinaman.cn/mybigdatas/ids/static/theme.png",
  indexText17: "Confirmed Keynote Speakers",
  indexText18: [
    [{
      num: "002",
      title: "Prof. Arun S. Mujumdar",
      text: "McGill University",
      tip: "Canada",
    },
    {
      num: "001",
      title: "Prof. Alex Martynenko",
      text: "Dalhousie University",
      tip: "Canada",
    },
    {
      num: "018",
      title: "Prof. Azharul Karim",
      text: "Queensland University of Technology",
      tip: "Australia",
    },
    {
      num: "007",
      title: "Prof. Benu Adhikari",
      text: "RMIT University",
      tip: "Australia",
    },
    {
      num: "003",
      title: "Prof. Bhesh Bhandari",
      text: "University of Queensland",
      tip: "Australia",
    },
    {
      num: "017",
      title: "Dr. Chinnaswamy Anandharamakrishna",
      text: "CSIR-NIIST",
      tip: "India",
    },
    ],
    [{
      num: "006",
      title: "Prof. Chung Lim Law",
      text: "University of Nottingham Malaysia",
      tip: "Malaysia",
    },
    {
      num: "012",
      title: "Prof. Duu-Jong Lee",
      text: "City University of Hong Kong",
      tip: "China",
    },
    {
      num: "009",
      title: "Prof. Evangelos Tsotsas",
      text: "Otto von Guericke University Magdeburg",
      tip: "Germany",
    },
    {
      num: "022",
      title: "Prof. Gennadiy Semenov",
      text: "Russian Biotechnological University",
      tip: "Russia",
    },
    {
      num: "011",
      title: "Prof. Hongwei Xiao",
      text: "China Agricultural University",
      tip: "China",
    },
    {
      num: "013",
      title: "Prof. Ireneusz Zbiciński",
      text: "Lodz University of Technology",
      tip: "Poland",
    },
    ],
    [{
      num: "015",
      title: "Prof. Itaya Yoshinori",
      text: "Gifu University",
      tip: "Japan",
    }, {
      num: "021",
      title: "Prof. Jamal Yagoobi",
      text: "Worcester Polytechnic Institute",
      tip: "America",
    },
    {
      num: "014",
      title: "Prof. Patrick Perre",
      text: "CentraleSupélec, Université Paris-Saclay",
      tip: "France",
    },
    {
      num: "016",
      title: "Prof. Peng Xu",
      text: "China Jiliang University",
      tip: "China",
    },
    {
      num: "004",
      title: "Prof. Sakamon Devahastin",
      text: "King Mongkut's University of Technology Thonburi",
      tip: "Thailand",
    },
    {
      num: "023",
      title: "Prof. Shaojin Wang",
      text: "Northwest A&F University",
      tip: "China",
    },
    ],
    [{
      num: "024",
      title: "Dr. Sheyla Ramsay",
      text: "PepsiCo, Inc.",
      tip: "America",
    },
    {
      num: "008",
      title: "Prof. Shusheng Pang",
      text: "University of Canterbury",
      tip: "New Zealand",
    }, {
      num: "010",
      title: "Prof. Song Miao",
      text: "Teagasc Food Research Centre",
      tip: "Ireland",
    }, {
      num: "019",
      title: "Prof. Vijaya Raghavan",
      text: "McGill University",
      tip: "Canada",
    },
    {
      num: "005",
      title: "Prof. Xiao Dong Chen",
      text: "Soochow University",
      tip: "China",
    },
    {
      num: "020",
      title: "Prof. Xu Duan",
      text: "Henan University of Science and Technology",
      tip: "China",
    },
    ],
    [{
      num: '025',
      title: "Prof. Zhongli Pan",
      text: "University of California, Davis",
      tip: "America"
    }]
  ],
  indexText19: "Contact us",
  indexText20: "Address:",
  indexText21: "School of Food Science and Technology, Jiangnan University, Wuxi, China",
  indexText22: "E-mail:",
  indexText23: "ids2024@jiangnan.edu.cn",
  indexText24: "Website:",
  indexText25: "www.ids2024.com",
  indexText26: "Login successful",
  indexText27: '<div class="em-web" style="display:flex"><p><b> E-mail:</b> ids2024@jiangnan.edu.cn</p><p><b> Website:</b> www.ids2024.com</p></div>',
  indexText28: "en",
  indexText29: "",
  indexText30: "",

  indexmsgemail: "Please enter your email address",
  indexmsgpwd: "Please enter your Password",
  // index

  //footer
  footReserved: 'Copyright © FBFNC2024. All Rights Reserved',
  footSymposium: 'FBFNC2024 | 2024 4th International Conference on Advanced Materials and Chemical Engineering',
  footText1: "Beijing ICPB 20012029-3",

  //organizing
  organizingTitle: 'Jiangnan University',
  organizingsmalltitle: 'General information',
  organizingtext1: ' Jiangnan University, situated in Wuxi by beautiful Taihu Lake, is a national key “211 Project” university and is selected into “First- Class Discipline Project”, falling under the Ministry of Education.',
  organizingtext2: ' Jiangnan University’s roots stretch back to 1902 when its predecessor, San Jiang Normal School, began its first term.In 1958, Jiangnan University began its independent existence as Wuxi Institute of Light Industry, which later merged with two other colleges in 2001, and was renamed as Jiangnan University by the Ministry of Education.The university, with the area of 208 hectares, consists of 18 schools and is the home to 3, 410 staff and faculty members, 21, 260 full - time undergraduates, 13, 330 postgraduates and 308 international students.',
  organizingtext3: ' Known as “the pearl of China ’s higher education in light industry”,Jiangnan University has launched a new journey toward the strategic objective of “building itself into a research- driven university with distinctive characteristics”, abiding by the motto of “learning and practice to perfection”.',
  organizingsmalltitle2: 'Rankings',
  organizingtext5: 'In the fourth round of National Discipline Assessment by the Ministry of Education, our Food Science and Technology, Light Industry Technology and Engineering was assessed at an “A+” level, and Design at an “A -”level.According to ESI, Jiangnan University ranks No.57 in China and our 10 disciplines(agricultural science, engineering, chemistry, biology & biochemistry, materials science, clinical medicine, computer science, pharmacology and toxicology, environment and ecology, microbiology) fall within the top 1 % globally and agricultural science is in 0.12‰. Jiangnan University is placed 60 nationwide and is in the 598th position globally by the US News rankings.',
  organizingaddresss: 'Address',
  organizingaddressstext: '1800 Lihu Avenue. Wuxi. Jiangsu. 214122. China',
  organizingdetails: 'Please see the details:',
  organizingtext10: "Postal",
  organizingtext11: "214122",
  organizingtext12: "https://english.jiangnan.edu.cn/ABOUT_JU/Overview.htm",
  organizingtext4: '',

  //committee
  committeebigtitle: 'IDS 2024 Organizing Committee',
  committeeOrganizing: 'Organizing Committee',
  committeeheaderImg: 'http://music.chinaman.cn/mybigdatas/ids/static/commit.png',
  committeeScientific: 'Scientific Committee (IDS Advisory Panel)',
  committeepeopleList: [{
    name: "Zhang M.",
    text: "Jiangnan University, Wuxi, P.R. China (IDS 2024 Chairman)",
  },
  {
    name: "Bi J.F.",
    text: "Institute of Food Science and Technology, CAAS, Beijing, P.R. China",
  },
  {
    name: "Chen X.D.",
    text: "Soochow University, Suzhou, P.R. China",
  },
  {
    name: "Duan X.",
    text: "Henan University of Science and Technology, Luoyang, P.R. China",
  },
  {
    name: "Huang L.X.",
    text: "Institute of Chemical Industry of Forest Products, Nanjing, P.R. China",
  },
  {
    name: "Jin J.H.",
    text: "Nanjing Wildlife Comprehensive Utilization Research Institute, ACFSMC, Nanjing, P.R. China",
  },
  {
    name: "Li D.J.",
    text: "Institute of Agro-product Processing, JAAS, Nanjing, P.R. China",
  },
  {
    name: "Li S.B.",
    text: "Jiangsu BoLaiKe Refrigeration Science and Technology Development Co., Ltd., Changzhou, P.R. China",
  },
  {
    name: "Li Z.Y.",
    text: "Tianjin University of Science and Technology, Tianjin, P.R. China",
  },
  {
    name: "Wang S.J.",
    text: "Northwest A&F University, Yangling, P.R. China",
  },
  {
    name: "Wu Z.H.",
    text: "Tianjin University of Science & Technology, Tianjin, P.R. China",
  },
  {
    name: "Xiao H.W.",
    text: "China Agricultural University, Beijing, P.R. China",
  },
  {
    name: "Yu D.X.",
    text: "SOHAO FD-TECH CO., LTD., Qingdao, P.R. China",
  },
  {
    name: "Zha G.C.",
    text: "Changzhou Yibu Drying Equipment Co., Ltd., Changzhou, P.R. China",
  },
  {
    name: "Zhou C.S.",
    text: "Jiangsu University, Zhenjiang, P.R. China",
  },
  ],
  committeetableData: [{
    date: "1",
    name: "Mujumdar A.S. (Canada)",
    address: "Devahastin S. (Thailand)",
  },
  {
    date: "2",
    name: "Abdelghani, B. (Algeria)",
    address: "Abdenouri, N. (Morocco)",
  },
  {
    date: "3",
    name: "Akinola A. (Nigeria)",
    address: "Alves-Filho O. (Norway)",
  },
  {
    date: "4",
    name: "Andrieu J. (France)",
    address: "Barresi A. (Italy)",
  },

  {
    date: "5",
    name: "Bruttini R. (Italy)",
    address: "Bhandari B. (Australia)",
  },
  {
    date: "6",
    name: "Chen G. (Hong Kong, P.R. China)",
    address: "Chen X. D. (P.R. China)",
  },
  {
    date: "7",
    name: "Farkas I. (Hungary)",
    address: "Emam-Djomeh Z. (Iran)",
  },

  {
    date: "8",
    name: "Itaya Y. (Japan)",
    address: "Fortes M. (Brazil)",
  },
  {
    date: "9",
    name: "Kemp I. (UK)",
    address: "Kechaou N. (Tunisia)",
  },
  {
    date: "10",
    name: "Krokida M. (Greece)",
    address: "Kowalski S. (Poland)",
  },

  {
    date: "11",
    name: "Langrish T. (Australia)",
    address: "Kudra T. (Canada)",
  },
  {
    date: "12",
    name: "Leonard A. (Belgium)",
    address: "Law C.L. (Malaysia)",
  },
  {
    date: "13",
    name: "Miao S. (Ireland)",
    address: "Levy A. (Israel)",
  },

  {
    date: "14",
    name: "Opara L. (South Africa)",
    address: "Mulet A. (Spain)",
  },
  {
    date: "15",
    name: "Pang S. (New Zealand)",
    address: "Pakowski Z. (Poland)",
  },
  {
    date: "16",
    name: "Perré P. (France)",
    address: "Peczalski R. (France)",
  },
  {
    date: "17",
    name: "Rodriguez-Ramirez (Mexico)",
    address: "Raghavan V. (Canada)",
  },
  {
    date: "18",
    name: "Rosello C. (Spain)",
    address: "Renstrom R. (Sweden)",
  },

  {
    date: "19",
    name: "Prachayawarakorn S. (Thailand)",
    address: "Sarkar Md. S.H. (Bangladesh)",
  },
  {
    date: "20",
    name: "Sihem, B. (Tunisia)",
    address: "Schutyser M. (Netherlands)",
  },

  {
    date: "21",
    name: "Thorat B. (India)",
    address: "Taranto O. (Brazil)",
  }, {
    date: "22",
    name: "Tsotsas E. (Germany)",
    address: "Timofeev O. (Finland) ",
  }, {
    date: "23",
    name: "Zbicinski I. (Poland)",
    address: "Yagoobi J. (USA)",
  }, {
    date: "24",
    name: "Zhou W. (Singapore)",
    address: "Zhang, M. (P.R. China) ",
  },
  ],

  //session
  sessionbigtitle: 'Keynotes',
  sessiontitle: 'Confirmed Keynote Speakers',
  sessionText18: [{
    num: "002",
    title: "Prof. Arun S. Mujumdar",
    text: "McGill University",
    tip: "Canada",
  },
  {
    num: "001",
    title: "Prof. Alex Martynenko",
    text: "Dalhousie University",
    tip: "Canada",
  },
  {
    num: "018",
    title: "Prof. Azharul Karim",
    text: "Queensland University of Technology",
    tip: "Australia",
  },
  {
    num: "007",
    title: "Prof. Benu Adhikari",
    text: "RMIT University",
    tip: "Australia",
  },
  {
    num: "003",
    title: "Prof. Bhesh Bhandari",
    text: "University of Queensland",
    tip: "Australia",
  },
  {
    num: "017",
    title: "Dr. Chinnaswamy Anandharamakrishna",
    text: "CSIR-NIIST",
    tip: "India",
  },
  {
    num: "006",
    title: "Prof. Chung Lim Law",
    text: "University of Nottingham Malaysia",
    tip: "Malaysia",
  },
  {
    num: "012",
    title: "Prof. Duu-Jong Lee",
    text: "City University of Hong Kong",
    tip: "China",
  },
  {
    num: "009",
    title: "Prof. Evangelos Tsotsas",
    text: "Otto von Guericke University Magdeburg",
    tip: "Germany",
  },
  {
    num: "022",
    title: "Prof. Gennadiy Semenov",
    text: "Russian Biotechnological University",
    tip: "Russia",
  },
  {
    num: "011",
    title: "Prof. Hongwei Xiao",
    text: "China Agricultural University",
    tip: "China",
  },
  {
    num: "013",
    title: "Prof. Ireneusz Zbiciński",
    text: "Lodz University of Technology",
    tip: "Poland",
  },
  {
    num: "015",
    title: "Prof. Itaya Yoshinori",
    text: "Gifu University",
    tip: "Japan",
  },
  {
    num: "021",
    title: "Prof. Jamal Yagoobi",
    text: "Worcester Polytechnic Institute",
    tip: "America",
  },
  {
    num: "014",
    title: "Prof. Patrick Perre",
    text: "CentraleSupélec, Université Paris-Saclay",
    tip: "France",
  },
  {
    num: "016",
    title: "Prof. Peng Xu",
    text: "China Jiliang University",
    tip: "China",
  },
  {
    num: "004",
    title: "Prof. Sakamon Devahastin",
    text: "King Mongkut's University of Technology Thonburi",
    tip: "Thailand",
  },
  {
    num: "023",
    title: "Prof. Shaojin Wang",
    text: "Northwest A&F University",
    tip: "China",
  },
  {
    num: "024",
    title: "Dr. Sheyla Ramsay",
    text: "PepsiCo, Inc.",
    tip: "America",
  },
  {
    num: "008",
    title: "Prof. Shusheng Pang",
    text: "University of Canterbury",
    tip: "New Zealand",
  },
  {
    num: "010",
    title: "Prof. Song Miao",
    text: "Teagasc Food Research Centre",
    tip: "Ireland",
  },
  {
    num: "019",
    title: "Prof. Vijaya Raghavan",
    text: "McGill University",
    tip: "Canada",
  },
  {
    num: "005",
    title: "Prof. Xiao Dong Chen",
    text: "Soochow University",
    tip: "China",
  },
  {
    num: "020",
    title: "Prof. Xu Duan",
    text: "Henan University of Science and Technology",
    tip: "China",
  },
  {
    num: '025',
    title: "Prof. Zhongli Pan",
    text: "University of California, Davis",
    tip: "America"
  }
  ],
  //program
  programbigtitle: 'Keynotes',
  programbigtext: 'This page is under construction.',

  //submissions
  submissionsbigtitle: 'Submissions',
  submissionstitle1: 'Topics of Interest',
  submissionstitle2: 'Author Instructions',
  submissionstitle3: 'Important Dates',
  submissionstitle4: 'Submission Method',
  submissionstext42: 'Full paper should be prepared according to the following template:',
  submissdataList: [
    "Fundamentals, modeling, and simulation",
    "Physical properties and product quality",
    "Industrial processes and equipment",
    "Measurement and process control",
    "Energy and environmental issues",
    "Osmotic dehydration and drying",
    "Drying of gases and liquids",
    "Drying of powdered solids",
    "Drying in biomass energy applications",
    "Drying of food and agricultural materials",
    "Drying of biological and pharmaceutical materials",
    "Drying of chemicals and polymers",
    "Drying of wood, pulp and paper, forest products",
    "Novel drying technologies, R&D opportunities",
  ],
  submissionstext21: '1. The submitted abstract should be with a maximum of 150 words in',
  submissionstext22: ' 2. The full paper submitted should be a minimum of 5 pages and a maximum of 8 pages.',
  submissionstext23: '3. The work must be original and unpublished and not under review in any other conference or journal. All contributions will be peer-reviewed by the Scientific Committee based on their originality, significance, methodological soundness and clarity of exposition.',

  submissionstext31a: 'March 15, 2024:',
  submissionstext32a: 'March 31, 2024:',
  submissionstext33a: 'April 30, 2024:',
  submissionstext34a: 'June 15, 2024:',

  submissionstext31b: 'Deadline for abstract',
  submissionstext32b: 'Notification of abstract',
  submissionstext33b: 'Deadline for manuscript',
  submissionstext34b: 'Final notification of manuscript acceptance',

  submissionstext41: 'For those who want to do "Oral Presentation and Poster" or "Poster Only" , abstract should be prepared according to the following template: ',
  submissionstext43: 'Online Submission Link',
  submissionstext45: 'Online Submission Link',
  submissionstext46: 'Online Submission System',


  //reg
  regbigtitle: 'Registration',
  regtitle1: 'Registration & Payment',
  regtitle2: 'Refund Policy:',

  regtext11: '1. Please fill the information and complete the payment via',
  regtext11a: 'Online Registration & Payment Information.',
  regtext12: '2. Please email Payment Order ID & Payment Email to',
  regtext12a: 'and wait for the secretary’s confirmation.',

  regCategory: 'Category',
  regtableData: [{
    one: "Delegate",
    two: "USD 450",
    three: "USD 500",
  },
  {
    one: "Student",
    two: "USD 220",
    three: "USD 250",
  },
  {
    one: "Accompanying person",
    two: "USD 150",
    three: "USD 150",
  },
  ],
  regpayabout1: 'Early Bird registration Before July 01, 2024 aaa【including banquet&Cultural activity fee】',
  regpayabout2: 'Normal Full registration After July 01, 2024 aaa【excluding banquet&Cultural activity fee】',


  regtext21a: 'Jiangnan University Bank Account 1 (US Dollar Remittance):',
  regtext22a: 'Full name of payee: Jiangnan University',
  regtext23a: ' Beneficiary bank: Business Department, Bank of China Wuxi Branch',
  regtext24a: 'Account number: 474158228044',
  regtext25a: 'SWIFT CODE: BKCHCNBJ95C',
  regtext26a: '*Banquet & Cultural activity fee: USD 50.',

  regtext21b: 'Jiangnan University Bank Account 2 (RMB Remittance)',
  regtext22b: 'Account Name: Jiangnan University(江南大学)',
  regtext23b: 'Account Bank: Wuxi Jiangnan University Branch, Industrial and Commercial Bank of China(工商银行无锡江南大学支行)',
  regtext24b: 'Bank account number: 1103030709100000136',

  regtext31: 'Registrations that are cancelled before September 01, 2024 will be reimbursed at 80% of the fee. Cancellations made after September 01, 2024 will not be reimbursed.',
  regtext32: ' Cancellation and refund request must be made formally via email. No shows will not be refunded.The organizing committee is not responsible for problems beyond our control, such as weather conditions, campus conditions, travel difficulties, visa problems, etc.',
  regtext33: ' * The organizing committees reserves the right to change the dates and place of the conference due to force majeure.',
  regtext34: ' * Losses thus incurred from the force majeure events shall not be liabled and refunds policy shall not apply as well.',

  submissionstext44: 'Online Submission System',
  //awards

  awardstitle: 'IDS 2024 Awards',
  awardstitle1: '1. Arun S Mujumdar Medal',
  awardstitle2: '2. IDS Chairman’s Award',
  awardstitle3: '3. Outstanding Drying Research Award',
  awardstitle4: '4. Excellent Drying Research Award',
  awardstitle5: '5. Young Drying Scientist Award',
  awardstitle6: '6. Oral Presentation Award',
  awardstitle7: '7. Poster Presentation Award',

  //sponsors
  sponsorsbigtitle: 'Sponsors',
  sponsorstext: 'This page is under construction.',

  //visa
  visabigtitle: 'Visa',
  visabigtitle1: 'VISA information:',
  visatext1: ' VISA Invitation Letters may be provided upon request. In order for the request to be honored, you must be the author or co- author of an accepted abstract.Please download this',
  visatext2: 'Invitation Letter Template,',
  visatext3: 'fill in your information and',
  visatext4: 'Upload',
  visatext5: 'it in "My Conference Dashboard".',
  visatext6: 'After signed and stamped, it will emailed to you.',
  visatext7: '* Important information regarding invitation letters (please read):',
  visatext8: 'Please note IDS2024 Conference and the organizing committee of the conference are not authorized to assist with the VISA process beyond providing the Notification of Invitation Letter issued by IDS2024 Conference and conference Committee Board. Should your application be denied, IDS2024 Conference and the organizing committee of the conference cannot change the decision of the Ministry of Foreign Affairs, nor will IDS2024 Conference and the organizing committee of the conference engage in discussion or correspondence with the MOFA or the Embassy on behalf of the applicant. ',
  visatext9: 'It takes time for the Embassy to process the VISA application, please register as early as you can to make sure you have enough time.',


  //travel
  travelbigtitle: 'Travel',
  traveltext1: 'The FIFS & ISNFF 2024 will be held in the Worldhotel Grand Juna Hotel Wuxi.',
  traveltext2: 'Worldhotel Grand Juna Wuxi',
  traveltext3: ' ：111 Hefeng Road, Binhu District,Wuxi, Jiangsu, P.R.China',
  traveltext4: 'Hotel Website:',
  traveltext5: 'https://wx.huieke.cn/expo/hotel/listing?eventid=1667315817&orgid=1675422796&lang=en',
  travelText6: "en",
  //traveltwo
  traveltwobigtitle: 'Discover Wuxi',
  traveltwotext: 'This page is under construction.',

  //hotel
  hotelbigtitle: 'Hotel',
  hoteltext: 'This page is under construction.',


  //submissionUpload
  submissionUploadtitle: 'Conference info',
  submissionUploadtext1: '2024 International Conference on Food Bioscience and Food Nutrition',
  submissionUploadtext2: 'Conference Date:',
  submissionUploadtext3: 'December 3-6, 2024',
  submissionUploadtext4: 'Venue',
  submissionUploadtext5: 'Worldhotel Grand Juna Wuxi, Wuxi, China',
  // submissionUploadtext5: "Please enter a title",

  submissionUploadtitle: 'Paper info',

  submissionUploadtext21: 'Author Information',
  submissionUploadtext22: 'Email address will only be used for communication with the authors，corresponding author will receive email from the system about this submission, at least one corresponding author should be marked.',
  submissionUploadAuthor: 'Author',
  submissionUploadAuthortext: '(Please fill in at least one author information)',
  submissionUploadtext23: 'Click here to add more authors',
  submissionUploadtext24: 'delete',
  submissionUploadtext25: 'Submitted Successfully!',
  submissionUploadtext26: "The file size cannot exceed 200M",
  submissionUploadtext30: 'First Name:*',
  submissionUploadtext31: 'Middle Name:',
  submissionUploadtext32: 'Last Name:*',
  submissionUploadtext33: 'Position:',
  submissionUploadtext34: 'Affiliation:*',
  submissionUploadtext35: 'Email:*',
  submissionUploadtext36: 'Corresponding author:',
  submissionUploadtext37: 'Oral/Poster presentation author:',
  submissionUploadtext38: 'position',
  submissionUploadtext39: '',
  submissionUploadtext40: '',


  submissionUploadmoreauthors: 'Click here to add more authors',

  submissionUploadmessageTitle: "Please enter title",
  submissionUploadmessageAbstract: "Please enter Abstract",
  submissionUploadmessagekeyword: "Please enter keyword",
  submissionUploadmessagefile: "Please upload the file",
  submissionUploadmessageauthor: "Please enter author",

  submissionUploadmessageauthor1: "Please enter Author",
  submissionUploadmessageauthor1Firstname: "s Firstname",
  submissionUploadmessageauthor1Lastname: "s Lastname",
  submissionUploadmessageauthor1Position: "s Position",
  submissionUploadmessageauthor1Affiliation: "s Affiliation",
  submissionUploadmessageauthor1email: "s email",

  submissionUploadSubmissionType: 'Submission Type:*',
  submissionUploadAbstract: 'Abstract (Oral Presentation or Poster)',
  submissionUploadPosterOnly: 'Abstract (Poster  Only)',
  submissionUploadFullpaper: 'Full paper submission is not available now. When your Abstract is notified of acceptance on March 31, 2024, you may choose to begin the full paper submission.',
  submissionUploadtitleandAbstract: 'Title And Abstract',
  submissionUploadTitle: 'Title:',
  submissionUploadTitleAbstract: 'Abstract:',
  submissionUploadAbstractabout: 'The title and the abstract should be entered as plain text, they should not contain HTML elements.',
  submissionUploadKeywords: 'Keywords:',
  submissionUploadKeywordsabout: 'Specify at least three keywords, separated by comma.:',
  submissionUploadselect: 'select file:',
  submissionUploadabouts: 'If you have compeleted the form, Please press the "Submission" button below.Uploading may take a while, please do not click the button twice.',

  submissionUploadSubmission: 'Submission',
  submissionUploadPeopleList: [
    [{
      text: "First Name:*",
      value: "",
      radio: "a",
    },
    {
      text: "Middle Name:",
      value: "",
      radio: "a",
    },
    {
      text: "Last Name:*",
      value: "",
      radio: "a",
    },
    {
      text: "Position:",
      value: "",
      radio: "c",
      list: [{
        text: "Position",
      },
      {
        text: "Prof.",
      },
      {
        text: "Associate Prof.",
      },
      {
        text: "Assiatant Prof.",
      },
      {
        text: "Dr.",
      },
      {
        text: "Master",
      },
      {
        text: "Seniot Lecturer",
      },
      {
        text: "Lecturer",
      },
      {
        text: "Ph.D student",
      },
      {
        text: "Master student",
      },
      {
        text: "Undergraduate student",
      },
      {
        text: "Others",
      },
      ],
    },
    {
      text: "Affiliation:*",
      value: "",
      radio: "a",
    },
    {
      text: "Email:*",
      value: "",
      radio: "a",
    },
    {
      text: "Corresponding author:",
      value: "1",
      radio: "b",
    },
    {
      text: "Oral/Poster presentation author:",
      value: "1",
      radio: "d",
    },
    ],
  ],
  submissionUploadItem: [{
    text: "First Name:*",
    value: "",
    radio: "a",
  },
  {
    text: "Middle Name:",
    value: "",
    radio: "a",
  },
  {
    text: "Last Name:*",
    value: "",
    radio: "a",
  },
  {
    text: "Position:*",
    value: "",
    radio: "c",
    list: [{
      text: "Position",
    },
    {
      text: "Prof.",
    },
    {
      text: "Associate Prof.",
    },
    {
      text: "Assiatant Prof.",
    },
    {
      text: "Dr.",
    },
    {
      text: "Master",
    },
    {
      text: "Seniot Lecturer",
    },
    {
      text: "Lecturer",
    },
    {
      text: "Ph.D student",
    },
    {
      text: "Master student",
    },
    {
      text: "Undergraduate student",
    },
    {
      text: "Others",
    },
    ],
  },
  {
    text: "Affiliation:*",
    value: "",
    radio: "a",
  },
  {
    text: "Email:*",
    value: "",
    radio: "a",
  },
  {
    text: "Corresponding author:",
    value: "1",
    radio: "b",
  },
  {
    text: "Oral/Poster presentation author:",
    value: "1",
    radio: "d",
  },
  ],
  //loginThen
  loginThenbigtitle: 'My Conference Dashboard',
  loginThentitle1: 'Online Submission System',
  loginThentitle12: '(Abstract/Full paper)',
  loginThentitle2: 'Registration',
  loginThentitle3: 'Payment',
  loginThentitle4: 'Invitation Letter',
  loginThentextabout: 'For speakers, you need to upload an "Abstract"',
  loginThenUpload: 'Upload',

  loginThenPaperID: 'Paper ID',
  loginThentitle: 'Title',
  loginThensubmissionType: 'Submission Type',
  loginThenkeywords: 'Keywords',
  loginThensuEdit: 'Edit',
  loginThenDelete: 'Delete',

  //simpleReg
  simpleRegTitle: 'title',
  simpleRegFirstname: 'Firstname',
  simpleRegLastname: 'Lastname',
  simplePassword: 'Password',
  simplePasswordpic: 'The password length needs to be 6-15',
  simpleRetypePassword: 'Retype Password',
  simpleCode: 'Verification Code* (Case sensitive)',
  simpleSignin: 'Sign in',
  simpleSignintip1: 'Already have an account?',
  simpleSignintip2: 'Please login',

  simpleSignmsgemail: 'Please enter your email address',
  simpleSignmsgFirstname: 'Please enter your Firstname',
  simpleSignmsgLastname: 'Please enter your Lastname',
  simpleSignmsgPassword: 'Please enter your Password',

  simpleSignmsgRetypePassword: 'Please enter your Retype Password',
  simpleSignmsgPasswordinconsistency: 'Password inconsistency',

  simpleSignmsgpasswordpic: 'The password length needs to be 6-15',
  simpleSignmsgCode: 'Please enter Verfication Code',
  simpleSignmsgCodeinconsistency: 'Verfication Code inconsistency',
  simpleSignmsgRegistrationsuccessful: 'Registration successful',

  newsDetailText1: 'Extension abstract submission deadline is March 15',
  newsDetailText2: '[Notification] The deadline for abstract submission is extended until March 15.',
  newsDetailText3: 'We hope to make the symposium more informative and interesting by giving more people the opportunity to actively participate in the symposium and share their latest research results.',
  newsDetailText4: 'Looking forward for your abstract, we look forward to your participation in IDS2024!',
  newsDetailText5: '1 Week Left to Deadline for Abstract Submission',
  newsDetailText6: '-- Updated on March 8, 2024',
  newsDetailText7: 'en',
  newsDetailText8: '1 Week Left to Deadline for Full Paper Submission',
  newsDetailText9: "-- Updated on April 23, 2024"
}


// WEBPACK FOOTER //
// ./src/utils/en.js